import React, { useState } from "react";
import { RxCross2 } from "react-icons/rx";

const SettingsModal = ({ isOpen, onClose }) => {
  const [checkPercent, setCheckPercent] = useState("0.1");
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center mx-4 justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg w-full lg:w-[600px] pb-6 shadow-lg">
        <div className="flex items-center justify-between p-[20px] border-b-[#ececfe] border-b-[1px]">
          <div className="text-[#000] text-[20px] font-[500]">Settings</div>
          <button
            onClick={onClose}
            className="text-gray-500 text-[20px] hover:text-gray-700"
          >
            <RxCross2 />
          </button>
        </div>
        <div className="px-[20px] pt-6">
          <div className="text-[16px] font-[500] text-[#8c8cb1]">
            Slippage tolerance
          </div>
          <div className="flex items-center gap-3 my-4">
            <div className="w-2/12">
              <button
                type="button"
                className={`w-full h-[50px] flex items-center justify-center  rounded-[8px] ${
                  checkPercent == "0.1"
                    ? "bg-[#afafaf] text-[#fff]"
                    : "bg-gray-100 text-gray-500"
                }`}
                onClick={() => setCheckPercent("0.1")}
              >
                0.1%
              </button>
            </div>
            <div className="w-2/12">
              <button
                type="button"
                className={`w-full h-[50px] flex items-center justify-center  rounded-[8px] ${
                  checkPercent == "0.5"
                    ? "bg-[#afafaf] text-[#fff]"
                    : "bg-gray-100 text-gray-500"
                }`}
                onClick={() => setCheckPercent("0.5")}
              >
                0.5%
              </button>
            </div>
            <div className="w-2/12">
              <button
                type="button"
                className={`w-full h-[50px] flex items-center justify-center  rounded-[8px] ${
                  checkPercent == "1"
                    ? "bg-[#afafaf] text-[#fff]"
                    : "bg-gray-100 text-gray-500"
                }`}
                onClick={() => setCheckPercent("1")}
              >
                1%
              </button>
            </div>
            <div className="w-6/12">
              <div className="flex items-center gap-1">
                <input
                  type="number"
                  className="border-none bg-gray-100 outline-none px-2 w-full rounded-[8px] h-[50px]"
                  placeholder="0.1"
                />
                <div className="text-[14px] text-[text-gray-500]">%</div>
              </div>
            </div>
          </div>
          <div className="text-[16px] font-[500] mb-2 text-[#8c8cb1]">
            Transaction Deadline
          </div>
          <div className="flex items-center gap-4">
            <div className="w-3/12">
              <input
                type="number"
                className="border-none bg-gray-100 outline-none px-2 w-full rounded-[8px] h-[50px]"
              />
            </div>
            <div className="text-[#8c8cb1] text-[14px] font-[500]">Minutes</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;
